var KG_TO_LBS_CONVERSION_RATE = 2.20462;
var CM_TO_FEET_CONVERSION_RATE = 0.0328084;
export var centimetersToFeet = function (input) {
    var feet = Math.floor(input * CM_TO_FEET_CONVERSION_RATE);
    var inches = Number(((input * CM_TO_FEET_CONVERSION_RATE) % 1).toFixed(2)) * 12;
    return {
        feet: Number(feet.toFixed(0)),
        inches: Number(inches.toFixed(0)),
    };
};
export var feetToCentimeters = function (input) {
    return Number((input / CM_TO_FEET_CONVERSION_RATE).toFixed(0));
};
var convertMetric = function (currentValue, currentMetric) {
    switch (currentMetric) {
        case 'kg':
            return {
                value: Number((currentValue * KG_TO_LBS_CONVERSION_RATE).toFixed(0)),
                metric: 'lbs',
            };
        case 'lbs':
            return {
                value: Number((currentValue / KG_TO_LBS_CONVERSION_RATE).toFixed(0)),
                metric: 'kg',
            };
        case 'cm':
            return {
                value: centimetersToFeet(currentValue),
                metric: 'feet',
            };
        case 'feet':
            return {
                value: feetToCentimeters(currentValue),
                metric: 'cm',
            };
    }
};
export default convertMetric;
